import React from 'react';
import './Skeleton.css';

export const SkeletonElement = ({ type, style }) => {
  return <div className={`skeleton ${type}`} style={style}></div>;
};

export const JobCardSkeleton = () => (
  <div className="job-card-skeleton">
    <SkeletonElement type="title" style={{ width: '60%' }} />
    <SkeletonElement type="text" style={{ width: '40%' }} />
    <SkeletonElement type="text" style={{ width: '30%' }} />
    <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
      <SkeletonElement type="text" style={{ width: '80px', height: '24px', borderRadius: '12px' }} />
      <SkeletonElement type="text" style={{ width: '80px', height: '24px', borderRadius: '12px' }} />
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px', alignItems: 'center' }}>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <SkeletonElement type="avatar" style={{ width: '30px', height: '30px' }} />
        <SkeletonElement type="text" style={{ width: '100px', margin: 0 }} />
      </div>
      <SkeletonElement type="text" style={{ width: '80px', margin: 0 }} />
    </div>
  </div>
);

export const ProfileSkeleton = () => (
  <div className="profile-skeleton">
    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
      <SkeletonElement type="avatar" style={{ width: '80px', height: '80px' }} />
      <div style={{ flex: 1 }}>
        <SkeletonElement type="title" />
        <SkeletonElement type="text" style={{ width: '60%' }} />
        <SkeletonElement type="text" style={{ width: '40%' }} />
      </div>
    </div>
    <div style={{ marginTop: '20px' }}>
      <SkeletonElement type="title" style={{ width: '30%' }} />
      <SkeletonElement type="text" />
      <SkeletonElement type="text" />
      <SkeletonElement type="text" style={{ width: '80%' }} />
    </div>
  </div>
);

export const ListSkeleton = ({ count = 5 }) => (
  <div className="list-skeleton">
    {Array(count).fill(0).map((_, i) => (
      <JobCardSkeleton key={i} />
    ))}
  </div>
);

export const FullPageSkeleton = () => (
  <div className="page-skeleton-container">
    <div style={{ marginBottom: '30px' }}>
      <SkeletonElement type="title" style={{ width: '250px' }} />
    </div>
    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
      <div style={{ flex: '1 1 60%', minWidth: '300px' }}>
        <ListSkeleton count={4} />
      </div>
      <div style={{ flex: '1 1 30%', minWidth: '250px' }}>
        <ProfileSkeleton />
      </div>
    </div>
  </div>
);
